import classnames from "classnames";
import React from "react";
import BackgroundImage from "../../components/BackgroundImage/BackgroundImage";
import ImgSrcGenerator from "../../containers/ScreenSaver/ImgSrcGenerator";

// tslint:disable-next-line:no-var-requires
const style = require("./ScreenSaver.scss");

interface ScreenSaverProps {
    timeoutInMillis: number;
    shopId: number;
    initImgId: number;
    numberOfSlides: number;
    imgSrcGenerator: ImgSrcGenerator;
}

interface ScreenSaverState {
    currentImgId: number;
}

class ScreenSaver extends React.Component<ScreenSaverProps, ScreenSaverState> {
    private interval: any;

    constructor(props: ScreenSaverProps) {
        super(props);
        this.state = { currentImgId: props.initImgId };
        this.incrementImgId = this.incrementImgId.bind(this);
    }

    public componentDidMount(): void {
        this.startSlideShow();
    }

    public componentWillUnmount(): void {
        clearInterval(this.interval);
    }

    public render() {
        const images = this.renderImages();

        return (
            <div className={classnames(style.screenSaverContainer)}>
                {images}
            </div>
        );
    }

    private startSlideShow(): void {
        this.interval = setInterval(
            () => this.changeSlide(),
            this.props.timeoutInMillis
        );
    }

    private renderImages() {
        const images = [];

        const lastImageId =
            this.props.initImgId + this.props.numberOfSlides - 1;
        for (let i = this.props.initImgId; i <= lastImageId; i++) {
            const image = this.renderImage(i);
            images.push(image);
        }

        return images;
    }

    private renderImage(imgId: number) {
        const imgSrc = this.props.imgSrcGenerator.generateImgSrc(
            this.props.shopId,
            imgId
        );
        const fallbackImgSrc = this.props.imgSrcGenerator.generateFallbackImgSrc(
            imgId
        );
        const isVisible = imgId === this.state.currentImgId;

        return (
            <BackgroundImage
                key={`bg-img-${imgId}`}
                isVisible={isVisible}
                imgSrc={imgSrc}
                fallbackImgSrc={fallbackImgSrc}
            />
        );
    }

    private changeSlide(): void {
        this.incrementImgId();
    }

    private incrementImgId(): void {
        const newImgId = this.getNextImgId();
        this.setState({ currentImgId: newImgId });
    }

    private getNextImgId() {
        let newImgId = this.state.currentImgId + 1;
        if (newImgId > this.props.numberOfSlides) {
            newImgId = this.props.initImgId;
        }
        return newImgId;
    }
}

export default ScreenSaver;
